module.exports = __webpack_public_path__ + "img/4-3-1-4-2-preview-IDEAS-e.ac12ca56.jpg";